<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
       

         <div class="ui form" [formGroup]="companyTccForm">

                <div class="field" [ngClass]="displayFieldCss('taxPayerName')">
                  <label>Payer’s Name</label>
                                    <input  formControlName="referenceNo" type="text" placeholder="Payer’s Name">
                  <app-field-error-display [displayError]="isFieldValid('taxPayerName')" errorMsg="Please company">
                  </app-field-error-display>
            </div>

                  <div class="field" [ngClass]="displayFieldCss('organizationTccId')">
                  <label>TTC ID</label>
                                    <input  formControlName="organizationTccId" type="text" placeholder="TTC ID">
                  <app-field-error-display [displayError]="isFieldValid('organizationTccId')" errorMsg="Please enter TTC ID">
                  </app-field-error-display>
            </div>
                 
            <div class=" field" [ngClass]="displayFieldCss('tccIssueDate')">
                  <label>Issue Date</label>
                  <input  formControlName="tccIssueDate" type="text" placeholder="Issue Date">
                        <app-field-error-display [displayError]="isFieldValid('tccIssueDate')" errorMsg="Please select Issued date">
                  </app-field-error-display>
                        </div>
                      <div class=" field" [ngClass]="displayFieldCss('tccExpiryDate')">
                  <label>Expiry Date</label>
                  <input  formControlName="tccExpiryDate" type="text" placeholder="Expiry Date">
                        <app-field-error-display [displayError]="isFieldValid('tccExpiryDate')" errorMsg="Please select Expiry date">
                  </app-field-error-display>
                        </div>
                  
                  <div class=" field" [ngClass]="displayFieldCss('taxOffice')">
                        <label>Tax Office</label>
                        <input  formControlName="taxOffice" type="text" placeholder="Tax Office">
                          <app-field-error-display [displayError]="isFieldValid('taxOffice')" errorMsg="Please select Tax office">
                              </app-field-error-display>
                                    </div>

                         <div class="field" [ngClass]="displayFieldCss('tccStatus')">
                              <label>TCC Status</label>
                              <select class="ui search dropdown">
                                    <option value="">TCC Status</option>
                                    </select>
                              <app-field-error-display [displayError]="isFieldValid('tccStatus')" errorMsg="Please select Tcc Status">
                              </app-field-error-display>
                        </div>
                                                      
                        
                                                            
                             

            




    </div>

 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="submit()" autofocus>Continue</button>

      </div>


